import { useRef, useState } from 'react';
import type { DateRange } from 'react-day-picker';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import DateRangePicker from 'components/DateRangePicker';
import ExportDropdown from 'components/ExportDropdown';
import Page from 'components/Page';

import ReportsFlightsGrid from './components/ReportsFlightsGrid';
import { RANGE_INTERVAL, TEST_ID } from './constants';
import type { FlightResponse, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ReportsPage: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => {
    const [dateRange, setDateRange] = useState<DateRange | undefined>(undefined);
    const [filterKey, setFilterKey] = useState(0);
    const [selectedFlights, setSelectedFlights] = useState<FlightResponse[]>([]);
    const dateRangeRef = useRef({
        endInputRef: { current: null },
        startInputRef: { current: null }
    });

    const handleDateRangeChange = (range: DateRange) => {
        setDateRange(range);

        const hasBothDates = range.from && range.to;
        const hasNoDates = !range.from && !range.to;

        if (!hasBothDates && !hasNoDates) {
            return;
        }

        setSelectedFlights([]);
        setFilterKey(previous => previous + 1);
    };

    return (
        <Page className={`${className} ${styles.reportsPage}`} testId={testId}>
            <HorizontalContainer className={styles.filterBar}>
                <DateRangePicker
                    className={styles.dateRangePicker}
                    onChange={handleDateRangeChange}
                    rangeInterval={RANGE_INTERVAL}
                    ref={dateRangeRef}
                    value={dateRange}
                />

                <ExportDropdown
                    className={styles.exportDropdown}
                    selectedFlights={selectedFlights}
                />
            </HorizontalContainer>

            <ReportsFlightsGrid
                key={filterKey}
                onSelectionChange={setSelectedFlights}
                startTimeFrom={dateRange?.from}
                startTimeTo={dateRange?.to}
            />
        </Page>
    );
};

export default ReportsPage;
